import { render, staticRenderFns } from "./BlockKennisbank.vue?vue&type=template&id=7e18951e&"
import script from "./BlockKennisbank.vue?vue&type=script&lang=js&"
export * from "./BlockKennisbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports